module.exports = __webpack_public_path__ + "img/24.9e0d24cf.png";